import { render, staticRenderFns } from "./editorPopoverDataRow.vue?vue&type=template&id=e86f32e0&scoped=true&"
import script from "./editorPopoverDataRow.vue?vue&type=script&lang=js&"
export * from "./editorPopoverDataRow.vue?vue&type=script&lang=js&"
import style0 from "./editorPopoverDataRow.vue?vue&type=style&index=0&id=e86f32e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86f32e0",
  null
  
)

export default component.exports